module.exports = __webpack_public_path__ + "static/mng-b5ec6a1c6207cd26919fbf9d07db1851.png";